<template>
    <div class="dashboardOrders__body__cover">
        <div v-for="(order, index) in orders" :key="index">
            <order-row :order="order" />
        </div>
        <div v-if="orders.length === 0 && !gettingOrders">
            <empty-component>
                <p>You have no orders</p>
            </empty-component>
        </div>
        
    </div>
</template>

<script>
import OrderRow from './OrderRow';
import EmptyComponent from '@/components/utils/EmptyComponent';
export default {
    props: ['orders','gettingOrders'],
    data() {
        return {

        }
    },
    components: {
        OrderRow,
        EmptyComponent
    }
}
</script>

<style>

</style>